import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class CalendarTemplateStore extends LocalModel {
    constructor() {
        super('calendarTemplate', {
            namePlural: 'calendarTemplates',
            sort: 'sort name',
            limit: 100,
            api: {
                search: {
                    url: '/api/calendarTemplates/',
                    params: {
                        limit: 100,
                        sort: 'sort name',
                    },
                },
                load: {
                    url: '/api/calendarTemplates/',
                    params: {},
                },
                save: {
                    url: '/api/calendarTemplates/',
                    params: {},
                },
                delete: {
                    url: '/api/calendarTemplates/',
                    params: {},
                },
            },
        });
    }

    @observable newCalendarTemplate = {};

    @observable calendarTemplate = {};

    @observable calendarTemplates = [];

    @observable categories = [];

}

const store = new CalendarTemplateStore();
export default store;
